// extracted by mini-css-extract-plugin
export var redoItem = "_ie-1";
export var redoTrigger = "_ie-0";